import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import CardHeader from '@material-ui/core/CardHeader';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '2%',
    },
    cardCustom: {
        padding: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        width: '300px',
        margin: '60px auto 50px auto',
    },
    displayInline: {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0,
        '& li': {
            display: 'inline-block',
        },
    },
}));

export default function TrialBalance({ letter, index, handleSave }) {
    const classes = useStyles();
    const history = useHistory();

    const navigate = () => {
        //console.log();
        history.push('/menu/addAdditional');
    };
    return (
        <>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <Accordion square defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                            <Typography className={classes.heading}>Upload other document's for feature reference</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <Grid container spacing={3} className="main-container">
                                <Grid item xs={12} sm={12} className="text-center">
                                    <FormControl className={classes.btnspace}>
                                        <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                            Attach other documents
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className="doc-container">
                                        <div className="doc-title">OB Verification Document</div>

                                        <div className="doc-action">
                                            <FontAwesomeIcon icon={faFileDownload} size="2x" />
                                            <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                        </div>
                                        <div className="clear" />
                                    </div>
                                    <div className="doc-container">
                                        <div className="doc-title">Master Document</div>

                                        <div className="doc-action">
                                            <FontAwesomeIcon icon={faFileDownload} size="2x" />
                                            <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                        </div>
                                        <div className="clear" />
                                    </div>
                                    <div className="doc-container">
                                        <div className="doc-title">Corporate Law Document</div>

                                        <div className="doc-action">
                                            <FontAwesomeIcon icon={faFileDownload} size="2x" />
                                            <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                        </div>
                                        <div className="clear" />
                                    </div>
                                    <div className="doc-container">
                                        <div className="doc-title">Process Testing Summary</div>

                                        <div className="doc-action">
                                            <FontAwesomeIcon icon={faFileDownload} size="2x" />
                                            <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                        </div>
                                        <div className="clear" />
                                    </div>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </CardContent>
            </Card>
            <Grid item sm={12} className={classes.fullWidth}>
                <div>
                    <ul className={classes.displayInline}>
                        <li>
                            <Button variant="contained" className="btnBlue ml10 txt-cap" color="primary" onClick={navigate}>
                                Next
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
        </>
    );
}
